import axios from "@/plugins/axios";
import store from "./../store/index";

async function apiListFiles() {
  const filesResponse = await axios.post("?Mode=General&Function=ListFiles");
  if (filesResponse.data.Status === "Success" && filesResponse.data.Result) {
    store.commit("setFiles", Object.values(filesResponse.data.Result));
  }
}

export { apiListFiles };
